import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const WarningYellow: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`, className)}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path style={{ fill: '#fee260' }} d="M8.5 0 0 17h17L8.5 0z" />
    <path
      d="M7.67 12.6v-5h1.66v5Zm0 2.5v-1.67h1.66v1.67Z"
      style={{ fill: '#231f20' }}
    />
  </svg>
);

export default WarningYellow;
